import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@helsenorge/designsystem-react/components/Button';
import { HNeventShowCookieBanner } from '../events';
const CookieBannerTrigger = (props) => {
    return (_jsx(Button, { onClick: () => HNeventShowCookieBanner(), variant: "outline", children: props.children }));
};
export default CookieBannerTrigger;
